/**
 * @generated SignedSource<<164c09725c82a1c955847812d96c2afe>>
 * @relayHash cae005a71f286b79f0dae1eb5a59c148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 39e5d92ae8af21d0967ebab383031b7dbd0667307e23f1fffe8e18c497da9fbc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTeamAdminControlsMode = "ALL_TEAMS" | "MEMBER_MANAGED_TEAMS" | "NO_TEAMS" | "VERIFIED_TEAMS" | "%future added value";
export type useTeamPickerQuery$variables = Record<PropertyKey, never>;
export type useTeamPickerQuery$data = {
  readonly confluence: {
    readonly siteConfiguration: {
      readonly teamAdminControlsSettings: {
        readonly teamAdminControlsMode: ConfluenceTeamAdminControlsMode | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useTeamPickerQuery = {
  response: useTeamPickerQuery$data;
  variables: useTeamPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "ConfluenceQueryApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSiteConfiguration",
        "kind": "LinkedField",
        "name": "siteConfiguration",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceTeamAdminControlsSettings",
            "kind": "LinkedField",
            "name": "teamAdminControlsSettings",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "teamAdminControlsMode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useTeamPickerQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTeamPickerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "cae005a71f286b79f0dae1eb5a59c148",
    "id": "39e5d92ae8af21d0967ebab383031b7dbd0667307e23f1fffe8e18c497da9fbc",
    "metadata": {},
    "name": "useTeamPickerQuery",
    "operationKind": "query",
    "text": "query useTeamPickerQuery{confluence{siteConfiguration{teamAdminControlsSettings{teamAdminControlsMode}}}}"
  }
};
})();

(node as any).hash = "60038e33d431932a72c598b7a97b028a";

export default node;
